module.exports = __webpack_public_path__ + "img/support_e3.22b7440b.png";